import { GlobalStateContext } from "GlobalState"
import classNames from "classnames"
import { useContext } from "react"
import BackBtn from "./BackBtn"
import Icon from "./Icon"
import { Column, Row } from "./Layout"
import css from "./PageHeader.module.scss"

function PageHeader({
  title,
  titleSmall,
  sticky = false,
  backBtn,
  settingsMenu,
  children,
  background = 'default'
}) {
  const { setShowSettingsMenu } = useContext(GlobalStateContext)

  return (
    <Column
      className={classNames(css.pageHeader, css[background])}
    >
      <Row align="msb" padding="lg 1.5rem xs" gap="sm">
        {backBtn && <BackBtn className={css.backBtn} />}

        <div col={1} style={{ minWidth: 0 }}>
          {title && <h1>{title}</h1>}
          {titleSmall && (
            <h4 className={classNames("ellipsis", css.titleSmall)}>
              {titleSmall}
            </h4>
          )}
        </div>

        {settingsMenu && (
          <Icon name="settings" onClick={() => setShowSettingsMenu(true)} />
        )}
      </Row>

      {children && <div padding="bottom-xs">{children}</div>}
    </Column>
  )
}

export default PageHeader
